module.exports = __webpack_public_path__ + "static/media/differential-fluid-exchange-red.3787654a.svg";